module.exports = __webpack_public_path__ + "img/my-equipment.157364ba.png";